<div class="container">
    <H1>View Branches</H1>

    <div style="padding-top: 15px;width: 300px;text-align: left;" > 
      <label>Search:</label>
      <div class="input-group mb-3">
        <input class="form-control" ID="details" name="details" type="text" [(ngModel)]="SearchValue" placeholder="Type in something to search"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary btnClear" type="button" id="button-addon2" (click)="ClearSearch()">X</button>
        </div>
      </div>
      <div>
        <button class="btn btn-success" type="button" id="button-addon2" (click)="btnDownloadReportClickExcel()">Export</button>
        <button class="btn btn-primary" type="button" id="button-addon2" (click)="Add()" style="margin-left: 20px;">Add</button>
      </div>
      
    </div>

    
    <table class="viewDataTable" ID="tblData">
      <thead>
        <tr>
          <th class="viewDataTableHeading"></th>
          <th class="viewDataTableHeading">Branch Name</th>
        </tr>
      </thead>

        <tr *ngFor="let data of data | filter:SearchValue| paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
            <td class="viewDataTableCell">
                <button type="submit" class="btn btn-primary btn-lg btn-block"  ID="btnViewData" (click)="EditData(data.ID)">Edit</button>
            </td>
            <td class="viewDataTableCell" style="min-width: 250px;">{{data.ID}}</td>
        </tr>

      </table>
      <pagination-controls (pageChange)="p = $event"></pagination-controls>

      <table class="viewDataTable" ID="tblDataExport" style="display: none;">
        <thead>
          <tr>
            <th class="viewDataTableHeading">Branch Name</th>
          </tr>
        </thead>
  
          <tr *ngFor="let data of data | filter:SearchValue">
              <td class="viewDataTableCell" style="min-width: 250px;">{{data.ID}}</td>
          </tr>
  
        </table>

    

</div>
